import axios from 'axios';
import get from 'lodash/get';
import { getJwtToken } from '../../services/auth';
import { Amplify } from '@aws-amplify/core';
import config from '../../config';

Amplify.configure(config);

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: getJwtToken(),
  },
});

const handleErroredResponse = async (error) => {
  const originalRequest = get(error, ['response', 'config'], undefined);
  const statusCode = get(error, ['response', 'status'], undefined);
  const errMessage = get(error, ['response', 'data', 'name'], undefined);
  const errData = get(error, ['response', 'data'], undefined);

  

  if (statusCode === 401) {
    if (errMessage === 'TokenExpiredError')  {
      const token = await getJwtToken();
      if (token) {
        axios.defaults.headers.common['Authorization'] = token;
      }
      return axiosConfig(originalRequest);
    }
  }

  if (statusCode === 410) {
    // For 410 errors, pass through the original error data to preserve the specific error message
    return Promise.reject(error);
  }

  // Ensure we always return a proper error object
  if (errData && typeof errData === 'object') {
    return Promise.reject(errData);
  } else if (errData && typeof errData === 'string') {
    return Promise.reject(new Error(errData));
  } else if (error.message) {
    return Promise.reject(new Error(error.message));
  } else {
    return Promise.reject(new Error('An unknown error occurred'));
  }
};

axiosConfig.interceptors.request.use(async (config) => {
  const aConfig = config;
  const authToken = await getJwtToken();
  if (authToken) {
    aConfig.headers["Authorization"] = authToken;
  }
  return aConfig;
}, error => Promise.reject(error));

axiosConfig.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return await handleErroredResponse(error);
  }
);

export default axiosConfig; 